import DashboardHome from "pages/dashboard/Dashboard";


export const path = "/home";

export const Component = DashboardHome;
